/**
 * No particular endpoint exists for this model-type.  This is a convenience model for
 * accessing data from within a Locale model.
 */

import CurrencyDenomination from 'app/src/data/models/CurrencyDenomination';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class CurrencyDenominationCollection extends RetailCollection {
  get model() {
    return CurrencyDenomination;
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.CurrencyDenomination is an array of the CurrencyDenomination structures we want.
    // So return it directly
    if (response.CurrencyDenomination) {
      return response.CurrencyDenomination;
    }
    return response;
  }
}
